// src/pages/ClientData/utils/masks.js

// Código do cliente: 5 dígitos numéricos
export const maskClientCode = (rawValue) => {
  return rawValue.replace(/\D/g, '').slice(0, 5);
};

// Código do processo: 00000.0000 (5 dígitos + ponto + 4 dígitos sequenciais)
export const maskProcessCode = (rawValue) => {
  const digits = rawValue.replace(/\D/g, '').slice(0, 9);
  if (digits.length <= 5) {
    return digits;
  }
  return `${digits.slice(0, 5)}.${digits.slice(5)}`;
};

// Extrai o código do cliente (5 dígitos) a partir de um código de processo "00000.0000"
export const getClientCodeFromProcessCode = (processCode) => {
  if (!processCode) return '';
  return processCode.split('.')[0].padStart(5, '0');
};
